module.exports = __webpack_public_path__ + "static/media/200x200.3f407475.jpg";